import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Dashboard.css';

// Determine API URL based on the current domain
const getApiUrl = () => {
    const hostname = window.location.hostname;
    // If accessing from prod domain, use prod API
    if (hostname === 'admin.eluum.com') {
        return 'https://api.eluum.com/api/auth/login';
    }
    // Otherwise use dev API (includes admin-dev.eluum.com and localhost)
    return 'https://api-dev.eluum.com/api/auth/login';
};

export const Login = () => {
        const [email, setEmail] = useState('');
        const [password, setPassword] = useState('');
        const [error, setError] = useState('');
        const [success, setSuccess] = useState(false);
        const [loading, setLoading] = useState(false);
        const navigate = useNavigate();

        const handleSubmit = async (e: React.FormEvent) => {
            e.preventDefault();
            setError('');
            setSuccess(false);

            if (!email || !password) {
                setError('Please enter both email and password');
                return;
            }

            setLoading(true);

            try {
                const response = await fetch(getApiUrl(), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    body: JSON.stringify({ email, password }),
                });

                if (!response.ok) {
                    throw new Error('Login failed');
                }

                const data = await response.json();

                // Check if user is an administrator
                const isAdmin = data.user?.groups?.includes('Administrators');

                if (!isAdmin) {
                    setError('Access denied. This application is for administrators only.');
                    setLoading(false);
                    return;
                }

                // Store tokens
                localStorage.setItem('accessToken', data.accessToken);
                localStorage.setItem('idToken', data.idToken);
                localStorage.setItem('refreshToken', data.refreshToken);
                localStorage.setItem('user', JSON.stringify(data.user));

                setSuccess(true);

                // Redirect to dashboard or home page
                setTimeout(() => {
                   navigate('/dashboard')
                }, 500);

            } catch (err) {
                setError('Invalid email or password');
            } finally {
                setLoading(false);
            }
        };

        return (
            <div className="login-page">
                <div className="login-card">
                    <h1 className="login-title">Admin Portal</h1>
                    <form onSubmit={handleSubmit} className="login-form">
                        <div className="form-group">
                            <label htmlFor="email">Email address</label>
                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="dashboard-input"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="dashboard-input"
                            />
                        </div>

                        {error && <p className="status status-error">{error}</p>}
                        {success && <p className="status status-success">Login successful!</p>}

                        <button type="submit" disabled={loading} className="btn btn-primary login-button">
                            {loading ? 'Logging in...' : 'Log in'}
                        </button>
                    </form>
                </div>
            </div>
        );
    };
